import {css} from 'lit';

export default css`

:host {
  --fixed-page-offset: 3.25rem;
  --fixed-header-scroll-offset: 4.0625rem;
}

.l-header__branding {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
}
@media (min-width: 992px) {
  .l-header__branding {
    min-height: 7.5rem;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
}
@media (max-width: 991px) {
  .l-header--fixed {
    padding-top: 3.25rem;
  }
}
@media (min-width: 992px) {
  .l-header--fixed.is-fixed .l-main {
    padding-top: var(--fixed-page-offset);
  }
}
.l-header--fixed .mobile-bar {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
}
.l-header--fixed [id] {
  scroll-margin-top: var(--fixed-header-scroll-offset);
}

.l-navbar {
  position: relative;
  z-index: 830;
  height: 100%;
  min-height: 3.25rem;
}
@media (max-width: 991px) {
  .l-navbar {
    position: absolute;
    top: 3.25rem;
    left: 0;
  }
}
@media (min-width: 992px) {
  .l-navbar {
    width: 100%;
    height: auto;
  }
}
@media (min-width: 992px) {
  .l-header--fixed .l-navbar.is-fixed {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .l-nav-horizontal {
    display: grid;
    grid-template-areas: "nav search quick";
    grid-template-columns: 1fr max-content max-content;
  }
  .l-nav-horizontal__primary-nav {
    grid-area: nav;
  }
  .l-nav-horizontal__search-popup {
    z-index: 3;
    grid-area: search;
  }
  .l-nav-horizontal__search-popup .search-popup__open {
    position: relative;
  }
  .l-nav-horizontal__quick-links {
    z-index: 2;
    grid-area: quick;
  }
}

.has-mega .l-navbar {
  position: absolute;
}
@media (min-width: 992px) {
  .has-mega .l-main {
    padding-top: 3.25rem;
  }
}

`;